import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MetricPerformanceData } from './metric-performance.metadata';

@Component({
    selector: 'cmps-metric-performance',
    template: `<div
        class="cmps-metric-performance-container"
        [class.cmps-metric-performance-child-container]="metricData?.isChild"
        (click)="clickAction.emit($event)"
    >
        <!-- toggle button -->
        <div
            class="cmps-metric-performance--toggle-icon-container"
            *ngIf="metricData?.isChild === false"
        >
            <button
                class="cmps-icon-button--no-bg"
                [cmpsTooltipTrigger]="
                    metricData.isExpanded
                        ? metricData.toggleStateTooltip?.collapsedTooltipLabel
                        : metricData.toggleStateTooltip?.expandedTooltipLabel
                "
                cmpsIconButton
                (click)="$event.stopPropagation(); toggleExpand.emit($event)"
            >
                <cmps-icon
                    [svgIcon]="
                        metricData.isExpanded
                            ? '__internal:chevron-down'
                            : '__internal:chevron-right'
                    "
                ></cmps-icon>
            </button>
        </div>

        <!-- Metric Name -->
        <ng-container *ngIf="!metricData?.user">
            <div class="cmps-metric-performance--title-section">
                <div
                    class="cmps-metric-performance--name"
                    [class.cmps-metric-performance--queue-name]="
                        metricData?.isChild
                    "
                    [cmpsTooltipTrigger]="metricData?.metricNameTooltip"
                >
                    {{ metricData.metricName }}
                </div>
            </div>
        </ng-container>

        <!-- User component -->
        <ng-container *ngIf="metricData?.user">
            <cmps-metric-user
                [user]="metricData.user"
                (onUserClick)="onUserClick(metricData.user)"
            >
            </cmps-metric-user>
        </ng-container>

        <!-- Data Area (Actual Value, Threshold, Trend) -->
        <div class="cmps-metric-performance--data-area">
            <!-- Check for No Actual Data Message -->
            <div *ngIf="metricData.noActualDataMessage; else actualContent">
                <span class="cmps-metric-performance--data-area-no-data">{{
                    metricData.noActualDataMessage
                }}</span>
            </div>
            <ng-template #actualContent>
                <!-- Actual Value -->
                <div *ngIf="metricData.trendValues">
                    <div
                        class="cmps-cdk-d-inline-block cmps-cdk-min-w-12px cmps-cdk-min-h-12p cmps-cdk-border-radius-4px"
                        [style.background]="
                            metricData.trendValues.thresholdColorGradient
                        "
                    ></div>
                    <span
                        class="cmps-cdk-pl-0dot25 cmps-metric-performance--actual-value"
                    >
                        {{ metricData.trendValues.actual }}
                    </span>
                </div>

                <!-- Trend -->
                <div
                    class="cmps-metric-performance--trend"
                    *ngIf="metricData.trendValues"
                    [attr.cmpsTooltipTrigger]="
                        showTrend !== false
                            ? metricData.trendValues?.trendViewText
                            : null
                    "
                    (click)="showTrend !== false && trendAction.emit($event)"
                >
                    <cmps-icon
                        [style.fill]="metricData.trendValues.trendColor"
                        [svgIcon]="
                            '__internal:' + metricData.trendValues.trendArrow
                        "
                    ></cmps-icon>
                    <span
                        class="cmps-cdk-pl-0dot25 cmps-metric-performance--trend-trend-value"
                    >
                        {{ metricData.trendValues.trendValue }}
                    </span>
                </div>
            </ng-template>
        </div>

        <!-- Progress Bar -->
        <div class="cmps-metric--progress-bar-section">
            <!-- Check for No Data Messages -->
            <ng-container
                *ngIf="
                    metricData.noTargetDataMessage || metricData.noDataMessage;
                    else progressBarContent
                "
            >
                <span class="cmps-metric-performance--data-area-no-data">{{
                    metricData.noTargetDataMessage || metricData.noDataMessage
                }}</span>
            </ng-container>
            <ng-template #progressBarContent>
                <cmps-metric-progress-bar
                    *ngIf="metricData.progressBarData"
                    [progressBarData]="metricData.progressBarData"
                ></cmps-metric-progress-bar>
            </ng-template>
        </div>
    </div> `,
})
export class CmpsMetricPerformanceComponent {
    @Input() metricData: MetricPerformanceData;
    @Input() showTrend: boolean;
    @Output() clickAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() toggleExpand: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() trendAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() onUserClickAction: EventEmitter<MouseEvent | KeyboardEvent>;

    constructor() {
        this.clickAction = new EventEmitter();
        this.toggleExpand = new EventEmitter();
        this.trendAction = new EventEmitter();
        this.onUserClickAction = new EventEmitter();
    }

    onUserClick(event: MouseEvent | KeyboardEvent): void {
        this.onUserClickAction.emit(event);
    }

    ngOnDestroy(): void {
        this.clickAction.complete();
        this.toggleExpand.complete();
        this.trendAction.complete();
        this.onUserClickAction.complete();
    }
}
